import ActivityDissemination from './activityDissemination.js';
export default ActivityDissemination;
